import styled from 'styled-components';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import CardBox from 'lib/components/CardBox';
import { brand } from 'themes/brand';

export const Container = styled(Box)`
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;
`;

export const Hero = styled(Box)`
  position: relative;
  overflow: hidden;
  background: ${brand.navyGradient};
  color: #fff;
  padding: 40px;
  border-radius: 12px;
  margin-bottom: 24px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0.15;
    pointer-events: none;
    background: radial-gradient(
        circle at 20% 20%,
        ${brand.glow},
        transparent 40%
      ),
      radial-gradient(circle at 80% 60%, ${brand.glow}, transparent 35%);
  }
`;

export const HeroContent = styled(Box)`
  position: relative;
`;

export const HeroBadgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const HeroBadge = styled(Chip)`
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  svg {
    color: #fff !important;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 34px;
  font-weight: 800;
  max-width: 640px;
  margin: 0;
  line-height: 1.25;
`;

export const HeroSubtitle = styled.p`
  margin-top: 12px;
  max-width: 640px;
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);

  strong {
    color: #fff;
  }
`;

export const SectionCard = styled(CardBox)`
  margin: 0 0 24px 0;
  padding: 24px 28px;

  h2 {
    margin: 0;
    font-size: 19px;
    font-weight: 700;
    color: ${brand.text};
  }

  .section-subtitle {
    margin-top: 4px;
    font-size: 15px;
    color: ${brand.textSecondary};
  }
`;

export const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const StepCard = styled.div`
  border: 1px solid ${brand.border};
  border-radius: 10px;
  padding: 16px;

  .step-number {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: ${brand.primaryDark};
  }

  .step-title {
    font-size: 15px;
    font-weight: 600;
    margin-top: 4px;
  }

  .step-description {
    font-size: 13px;
    color: ${brand.textSecondary};
    margin-top: 4px;
    line-height: 1.5;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;

  .section-eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${brand.primaryDark};
  }

  h2 {
    font-size: 21px;
    font-weight: 700;
    margin: 4px 0 0 0;
  }

  .section-description {
    font-size: 14px;
    color: ${brand.textSecondary};
    margin-top: 4px;
    max-width: 560px;
  }

  .section-note {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #98a2b3;
    margin-top: 8px;
  }
`;

export const Section = styled.section`
  margin-bottom: 32px;
`;
